<template>
    <footer :class="$style.footer">
        <div :class="$style.footerContentWrapper">
            <div 
                :class="[
                    $style.leftContent, 
                    {[$style.leftContentMdAndUp]: $vuetify.breakpoint.mdAndUp}
                ]" 
            >
                <div>
                    <img :src="vivomapLogo" :class="$style.logo"/>
                </div>
                <p :class="$style.becomePartner"  @click="openPartnerWebsite()">
                    <str index="footer > become_partner" />
                    <v-icon 
                        color="#0090c1" 
                        x-small 
                        :class="$style.externalLinkIcon">
                        fas fa-external-link-alt
                    </v-icon>
                </p>
            </div>
            <div
                :class="[
                    $style.rightContent, 
                    {[$style.rightContentMdAndUp]: $vuetify.breakpoint.mdAndUp}
                ]"
            >
                <div
                    :class="[
                        $style.linksWrapper, 
                        {[$style.linksWrapperMdAndUp]: $vuetify.breakpoint.mdAndUp},
                        {[$style.linksWrapperXl]: $vuetify.breakpoint.xlOnly}
                    ]"
                >
                    <div :class="$style.links">
                        <span @click="goAbout()">
                            <str index="menu > about_vivomap" />
                        </span>
                    </div>
                    <div :class="$style.links">
                        <span @click="goContactUs()">
                            <str index="menu > contact_us" />
                        </span>
                    </div>
                    <div :class="$style.links">
                        <span @click="goFAQ()">
                            <str index="menu > faq" />
                        </span>
                    </div>
                    <div :class="$style.links">
                        <span @click="openTarget('terms_of_use')">
                            <str index="site_regulation > terms of use" />
                        </span>
                    </div>
                    <div :class="$style.links">
                        <span @click="openTarget('privacy_policy')">
                            <str index="site_regulation > privacy policy" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div :class="$style.copyrightContent">
            {{ getCompanyName }} &copy; {{ getCurrentYear() }}.
            <str index="footer > content right"/>
        </div>
    </footer>
</template>

<script>
import vivomapLogo from '@/assets/images/logos/vivomap.png';
import { mapGetters } from 'vuex'
export default {
    name: 'Footer',

    data: function(){
        return {}
    },
    methods: {
        openTarget: function(siteRegulationTargetTab) {
            this.$controller.view.SiteRegulation.open(siteRegulationTargetTab);       
        },
        openPartnerWebsite: function() {
            window.open("https://ctccomm.com/medical_education/vivomap/", "_target")
        },
        goAbout: function(){
            this.$router.push({path: '/about'})
            this.$emit('close')
        },
        goContactUs: function() {
            this.$controller.view.contactUs.open();
            this.$emit('close');
        },
        goFAQ: function(){
            this.$router.push({path: '/faq'})
            this.$emit('close')
        },
        getCurrentYear: function() {
            let currentDate = new Date()
            let currentYear = currentDate.getFullYear()
            return currentYear
        }
    },
    computed:{
        vivomapLogo: function(){
            return vivomapLogo;
        },
        ...mapGetters([
            'getCompanyName',
        ])
    }
}
</script>

<style module>
/* footer style */
.footer {
    border: 1px solid #e6e6e6;
    height: auto;
    background-color: white;
    text-align: center;
    font-size: 15px;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;      
}

.footerContent {
    padding-top: 50px;
}

.footer a {
    display: block;
    -webkit-transition: 0.1s;
    -o-transition: 0.1s;
    transition: 0.1s;
    color: black;
    padding-bottom: 10px;
}

.footerContentWrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    width: 100%;
}

/* Mobile Sm and down */
.leftContent {
    width: 100%;
    text-align: left;
}

.leftContentMdAndUp {
    -ms-flex-preferred-size: 60%;
    flex-basis: 60%;
    padding-left: 40px;
}
    .logo {
        width: 225px;
        height: auto;
    }

    .becomePartner {
        margin-left: 25px;
        font-size: 1rem;
        color: #5c5f61;
        position: relative;
        margin-top: -5px;
        text-transform: uppercase;
        display: inline-block;
        cursor: pointer;
    }
        .externalLinkIcon {
            position: relative;
            margin-top: -0.25%;
            margin-left: 5px;
        }

/* Mobile Sm and down */
.rightContent {
    width: 100%;
    padding: 10px 0px;
}

.rightContentMdAndUp {
    -ms-flex-preferred-size: 35%;
        flex-basis: 35%;
}
    .linksWrapper {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        width: 100%;
        height: 100%;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
    }

    .linksWrapperXl {
        width: 70%;
        margin: auto;
    }
        .links {
            -ms-flex-preferred-size: 50%;
                flex-basis: 50%;
            text-align: center;
            padding: 5px 0px;
        }

        .linksWrapperMdAndUp .links{
            text-align: left;
            padding: 0px;
        }

            .links span {
                color: #666666;
                text-transform: uppercase;
                cursor: pointer;
            }

.copyrightContent {
    padding: 5px 0;
    width: 100%;
    color: #5c5f61;
    font-size: 0.9rem;
}
</style>
